import React, { Fragment } from 'react';
import { SchoolListing } from '../types/api';
import { SchoolCard } from './SchoolCard';
import { Sidebar } from './Sidebar';
interface SchoolListingsProps {
  schools: SchoolListing[];
  loading: boolean;
  error: string | null;
  selectedAreaId: number;
  selectedProgram: number;
  onProgramChange: (programId: number) => void;
  hideSidebar?: boolean;
}
export function SchoolListings({
  schools,
  loading,
  error,
  selectedAreaId,
  selectedProgram,
  onProgramChange,
  hideSidebar = false
}: SchoolListingsProps) {
  return <div className="w-full max-w-7xl mx-auto px-4 py-6 md:py-8" data-id="element-284">
      <div className={`flex flex-col ${hideSidebar ? '' : 'lg:flex-row'} gap-6`} data-id="element-285">
        {/* Main Content Area */}
        <div className={`w-full ${hideSidebar ? '' : 'lg:flex-1'} min-w-0`} data-id="element-286">
          {error && <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg mb-6" data-id="element-287">
              <p className="font-medium" data-id="element-288">Error loading schools</p>
              <p className="text-sm" data-id="element-289">{error}</p>
            </div>}

          {loading ?
        // Skeleton Loading State
        <div className="space-y-6" data-id="element-290">
              {[1, 2, 3, 4].map(i => <div key={i} className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 md:p-8 flex flex-col md:flex-row gap-6 animate-pulse" data-id="element-291">
                  <div className="w-16 h-16 bg-gray-200 rounded-full flex-shrink-0" data-id="element-292"></div>
                  <div className="flex-grow space-y-4" data-id="element-293">
                    <div className="h-6 bg-gray-200 rounded w-3/4" data-id="element-294"></div>
                    <div className="space-y-2" data-id="element-295">
                      <div className="h-4 bg-gray-200 rounded w-full" data-id="element-296"></div>
                      <div className="h-4 bg-gray-200 rounded w-5/6" data-id="element-297"></div>
                      <div className="h-4 bg-gray-200 rounded w-4/6" data-id="element-298"></div>
                    </div>
                  </div>
                  <div className="w-full md:w-48 h-12 bg-gray-200 rounded-lg flex-shrink-0 mt-4 md:mt-0" data-id="element-299"></div>
                </div>)}
            </div> : schools.length === 0 && !error ? <div className="bg-gray-50 border border-gray-200 text-gray-600 px-6 py-12 rounded-xl text-center" data-id="element-300">
              <p className="text-lg font-medium mb-2" data-id="element-301">
                No schools found for this area of study.
              </p>
              <p data-id="element-302">Please try selecting a different category.</p>
            </div> : <div className="space-y-5" data-id="element-303">
              {schools.map((school, index) => <Fragment key={`${school.mBrandID}-${index}`} data-id="element-304">
                  <SchoolCard school={school} rank={index + 1} isRecommended={index === 0} data-id="element-305" />
                  {index === 0 && schools.length > 1 && <div className="flex items-center justify-center gap-4 bg-gray-50 border border-gray-200 rounded-lg px-5 py-3" data-id="element-306">
                      <div className="flex items-center gap-2 flex-shrink-0" data-id="element-307">
                        <span className="bg-yellow-400 rounded-full w-8 h-8 flex items-center justify-center text-lg" data-id="element-308">
                          💡
                        </span>
                        <span className="text-xs font-bold text-gray-900 uppercase tracking-wider" data-id="element-309">
                          Did You Know?
                        </span>
                      </div>
                      <span className="text-sm text-gray-700" data-id="element-310">
                        Enrollments increased by 40% this year
                      </span>
                    </div>}
                </Fragment>)}
            </div>}
        </div>

        {/* Sidebar Area - only show if hideSidebar is false */}
        {!hideSidebar && <div className="w-full lg:w-56 xl:w-64 flex-shrink-0" data-id="element-311">
            <Sidebar selectedAreaId={selectedAreaId} selectedProgram={selectedProgram} onProgramChange={onProgramChange} data-id="element-312" />
          </div>}
      </div>
    </div>;
}